<template>
  <v-dialog v-model="openDialog" max-width="500px" persistent>
    <v-card>
      <v-toolbar flat color="secondary">
        <v-toolbar-title class="text-white">
          {{ $t("labels.rename") }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="white" @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text>
        <v-form ref="createForm" v-model="validName" lazy-validation>
          <v-row>
            <v-col cols="12">
              <p class="text-body-1">
                {{ $t("strings.rename-rule") }}
              </p>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="editedItem.name"
                :label="$t('labels.name')"
                variant="outlined"
                :rules="nameRule"
                required
                density="compact"
                name="ruleName"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary darken-1" variant="text" @click="closeDialog">
          {{ $t("labels.cancel") }}
        </v-btn>
        <v-btn
          color="secondary darken-1"
          variant="text"
          :disabled="!validName"
          @click="renameRule"
        >
          {{ $t("labels.rename") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "DialogRename",
  props: ["dialogRename", "nameToEdit"],
  data() {
    return {
      nameRule: [(value) => !!value || this.$t("errors.rule-name-required")],
      validName: false,
      editedItem: {
        name: "",
      },
    };
  },
  mounted() {
    this.editedItem.name = this.nameToEdit;
  },
  computed: {
    openDialog() {
      return this.dialogRename;
    },
  },
  methods: {
    closeDialog() {
      this.$emit("closeDialog");
    },
    renameRule() {
      this.$emit("renameRule", this.editedItem.name);
    },
  },
};
</script>

<style scoped></style>
